declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

export const useFacebookPixel = () => {
  const trackEvent = (event: string, data?: object) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, data);
    }
  };

  return {
    // Eventos estándar de Facebook
    trackPageView: () => trackEvent('PageView'),
    
    trackViewContent: (data: { 
      content_name: string; 
      content_category?: string;
      value?: number;
      currency?: string;
    }) => trackEvent('ViewContent', data),
    
    trackAddToCart: (data: {
      content_name: string;
      content_ids: string[];
      value: number;
      currency: string;
    }) => trackEvent('AddToCart', data),
    
    trackInitiateCheckout: (data: {
      content_name: string;
      value: number;
      currency: string;
    }) => trackEvent('InitiateCheckout', data),
    
    trackLead: (data?: {
      content_name?: string;
      value?: number;
      currency?: string;
    }) => trackEvent('Lead', data),
    
    trackCompleteRegistration: (data: {
      content_name: string;
      value: number;
      currency: string;
    }) => trackEvent('CompleteRegistration', data),
    
    // Evento personalizado
    trackCustom: (event: string, data?: object) => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('trackCustom', event, data);
      }
    }
  };
};

export default useFacebookPixel;
